import { render, staticRenderFns } from "./related-product.vue?vue&type=template&id=4743e9eb&scoped=true&"
import script from "./related-product.vue?vue&type=script&lang=js&"
export * from "./related-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4743e9eb",
  null
  
)

export default component.exports